import { cn } from "@/utils/utils";
import { Check } from "lucide-react";

interface CheckedLabelProps {
  label: string;
  checkClassName?: string;
  labelClassName?: string;
}

export const CheckedLabel = ({
  label,
  checkClassName,
  labelClassName,
}: CheckedLabelProps) => (
  <div className="flex items-start gap-2 text-[13px] leading-5 text-muted-foreground">
    <Check
      className={cn(
        "mt-0.5 h-3.5 w-3.5 flex-shrink-0 text-gray-400",
        checkClassName,
      )}
    />
    <span
      className={cn(
        "min-w-0 text-[13px] leading-5 text-muted-foreground",
        labelClassName,
      )}
    >
      {label}
    </span>
  </div>
);
